var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { PureComponent } from 'react';
import styled, { css } from 'react-emotion';
import Dialog from './dialog';
import { DefaultButton, GreenButton } from './buttons';
var hideOnMobile = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (max-width: 600px) {\n    display: none;\n  }\n"], ["\n  @media (max-width: 600px) {\n    display: none;\n  }\n"])));
var TableScroll = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-x: auto;\n  margin-top: 16px;\n"], ["\n  overflow-x: auto;\n  margin-top: 16px;\n"])));
var Table = styled('table')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-collapse: collapse;\n  font-size: 12px;\n"], ["\n  border-collapse: collapse;\n  font-size: 12px;\n"])));
var ColumnHeading = styled('th')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: #031b4a;\n  font-weight: 700;\n  text-align: left;\n  border-width: 0;\n  word-break: normal;\n"], ["\n  color: #031b4a;\n  font-weight: 700;\n  text-align: left;\n  border-width: 0;\n  word-break: normal;\n"])));
var RowHeading = styled('th')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: normal;\n  text-align: left;\n  word-break: normal;\n"], ["\n  font-weight: normal;\n  text-align: left;\n  word-break: normal;\n"])));
var Row = styled('tr')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  th,\n  td {\n    vertical-align: top;\n    padding: 20px 32px;\n    border-top: none;\n    border-bottom: 1px solid rgba(67, 90, 111, 0.114);\n    &:first-child {\n      padding: 20px 0;\n    }\n    &:nth-child(2) {\n      padding: 20px 0 20px 32px;\n    }\n    &:nth-child(3) {\n      padding: 20px 0 20px 32px;\n    }\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n  &.last-row {\n    td,\n    th {\n      border-bottom: 0;\n    }\n  }\n"], ["\n  th,\n  td {\n    vertical-align: top;\n    padding: 20px 32px;\n    border-top: none;\n    border-bottom: 1px solid rgba(67, 90, 111, 0.114);\n    &:first-child {\n      padding: 20px 0;\n    }\n    &:nth-child(2) {\n      padding: 20px 0 20px 32px;\n    }\n    &:nth-child(3) {\n      padding: 20px 0 20px 32px;\n    }\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n  &.last-row {\n    td,\n    th {\n      border-bottom: 0;\n    }\n  }\n" // Simulate of a checkbox : reverse of radio button styles, display: block one, when the other is display: none
]))); // Simulate of a checkbox : reverse of radio button styles, display: block one, when the other is display: none

var InputCell = styled('td')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  label {\n    position: relative;\n    top 50%;\n    display: block;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    background: transparent\n    cursor: pointer;\n  }\n  label input {\n    position: absolute;\n    top: 0; left: 0;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n  label input.essential ~ .checkmark {\n    position: absolute;\n    top: 0; left: 0;\n    height: 13px; width: 13px;\n    border-radius: 2px;\n    background-color: #c9d1df;\n    border: 1px solid #c9d1df;\n    cursor: auto;\n    z-index: 2;\n  }\n  label input.essential ~ .checkmark:after {\n    position: absolute;\n    left: 4px; top: 1px;\n    width: 3px; height: 7px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    content: '';\n    display: block;\n  }\n  label input.true:checked ~ .checkmark {\n    background-color: #4fb767;\n    border: 1px solid #4fb767;\n  }\n  label input.true ~ .checkmark {\n    position: absolute;\n    top: 0; left: 0;\n    height: 13px; width: 13px;\n    border-radius: 2px;\n    background-color: white;\n    border: 1px solid #56709c;\n    cursor: pointer;\n    z-index: 2;\n  }\n  label input.true ~ .checkmark:after {\n    position: absolute;\n    left: 4px; top: 1px;\n    width: 3px; height: 7px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    content: '';\n    display: block;\n  }\n  label input.true ~ .checkmark:after {display: block}\n  label input.false:checked ~ .checkmark {\n    background-color: white;\n    border-color: #56709c;\n  }\n  label input.false ~ .checkmark {\n    position: absolute;\n    top: -4px; left: 0;\n    height: 13px; width: 13px;\n    border-radius: 2px;\n    background-color: #4fb767;\n    border: 1px solid #4fb767;\n    cursor: pointer;\n    z-index: 1;\n  }\n  label input.false ~ .checkmark:after {\n    position: absolute;\n    left: 4px; top: 1px;\n    width: 3px; height: 7px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    content: '';\n    display: block;\n  }\n  label input.false:checked ~ .checkmark:after {display: block}\n  label input.true:checked ~ .checkmark {\n    display: none;\n  }\n  label input.false:checked ~ .checkmark {\n    display: none;\n  }\n"], ["\n  label {\n    position: relative;\n    top 50%;\n    display: block;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    background: transparent\n    cursor: pointer;\n  }\n  label input {\n    position: absolute;\n    top: 0; left: 0;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n  label input.essential ~ .checkmark {\n    position: absolute;\n    top: 0; left: 0;\n    height: 13px; width: 13px;\n    border-radius: 2px;\n    background-color: #c9d1df;\n    border: 1px solid #c9d1df;\n    cursor: auto;\n    z-index: 2;\n  }\n  label input.essential ~ .checkmark:after {\n    position: absolute;\n    left: 4px; top: 1px;\n    width: 3px; height: 7px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    content: '';\n    display: block;\n  }\n  label input.true:checked ~ .checkmark {\n    background-color: #4fb767;\n    border: 1px solid #4fb767;\n  }\n  label input.true ~ .checkmark {\n    position: absolute;\n    top: 0; left: 0;\n    height: 13px; width: 13px;\n    border-radius: 2px;\n    background-color: white;\n    border: 1px solid #56709c;\n    cursor: pointer;\n    z-index: 2;\n  }\n  label input.true ~ .checkmark:after {\n    position: absolute;\n    left: 4px; top: 1px;\n    width: 3px; height: 7px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    content: '';\n    display: block;\n  }\n  label input.true ~ .checkmark:after {display: block}\n  label input.false:checked ~ .checkmark {\n    background-color: white;\n    border-color: #56709c;\n  }\n  label input.false ~ .checkmark {\n    position: absolute;\n    top: -4px; left: 0;\n    height: 13px; width: 13px;\n    border-radius: 2px;\n    background-color: #4fb767;\n    border: 1px solid #4fb767;\n    cursor: pointer;\n    z-index: 1;\n  }\n  label input.false ~ .checkmark:after {\n    position: absolute;\n    left: 4px; top: 1px;\n    width: 3px; height: 7px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    content: '';\n    display: block;\n  }\n  label input.false:checked ~ .checkmark:after {display: block}\n  label input.true:checked ~ .checkmark {\n    display: none;\n  }\n  label input.false:checked ~ .checkmark {\n    display: none;\n  }\n"])));

var PreferenceDialog =
/** @class */
function (_super) {
  __extends(PreferenceDialog, _super);

  function PreferenceDialog() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      onChange(e.target.name, e.target.value === 'true');
    };

    _this.handleSubmit = function (e) {
      var _a = _this.props,
          onSave = _a.onSave,
          preferences = _a.preferences,
          marketingAndAnalytics = _a.marketingAndAnalytics,
          advertising = _a.advertising,
          functional = _a.functional,
          customCategories = _a.customCategories;
      e.preventDefault(); // Safe guard against browsers that don't prevent the
      // submission of invalid forms (Safari < 10.1)

      if (!customCategories && (marketingAndAnalytics === null || advertising === null || functional === null)) {
        return;
      } // Safe guard against custom categories being null


      if (customCategories && Object.keys(customCategories).some(function (category) {
        return preferences[category] === null;
      })) {
        return;
      }

      onSave();
    };

    return _this;
  }

  PreferenceDialog.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        innerRef = _a.innerRef,
        onCancel = _a.onCancel,
        marketingDestinations = _a.marketingDestinations,
        advertisingDestinations = _a.advertisingDestinations,
        functionalDestinations = _a.functionalDestinations,
        marketingAndAnalytics = _a.marketingAndAnalytics,
        advertising = _a.advertising,
        functional = _a.functional,
        customCategories = _a.customCategories,
        destinations = _a.destinations,
        title = _a.title,
        content = _a.content,
        preferences = _a.preferences,
        lang = _a.lang;
    var buttons = React.createElement("div", null, React.createElement(DefaultButton, {
      type: "button",
      onClick: onCancel
    }, lang === 'it' ? 'Annulla ' : 'Annuler'), React.createElement(GreenButton, {
      type: "submit"
    }, lang === 'it' ? 'Salva' : 'Sauvegarder'));
    return React.createElement(Dialog, {
      innerRef: innerRef,
      title: title,
      buttons: buttons,
      onCancel: onCancel,
      onSubmit: this.handleSubmit
    }, content, React.createElement(TableScroll, null, React.createElement(Table, null, React.createElement("thead", null, lang === 'it' ? React.createElement(Row, null, React.createElement(ColumnHeading, {
      scope: "col"
    }, "Autorizza"), React.createElement(ColumnHeading, {
      scope: "col"
    }, "Categoria"), React.createElement(ColumnHeading, {
      scope: "col"
    }, "Obiettivo"), React.createElement(ColumnHeading, {
      scope: "col",
      className: hideOnMobile
    }, "Strumenti")) : React.createElement(Row, null, React.createElement(ColumnHeading, {
      scope: "col"
    }, "Autoriser"), React.createElement(ColumnHeading, {
      scope: "col"
    }, "Cat\xE9gorie"), React.createElement(ColumnHeading, {
      scope: "col"
    }, "But"), React.createElement(ColumnHeading, {
      scope: "col",
      className: hideOnMobile
    }, "Outils"))), React.createElement("tbody", null, !customCategories && React.createElement(React.Fragment, null, React.createElement(Row, null, React.createElement(InputCell, null, React.createElement("label", null, React.createElement("input", {
      className: "true",
      type: "radio",
      name: "functional",
      value: "true",
      checked: functional === true,
      onChange: this.handleChange,
      "aria-label": "Activer le suivi fonctionnel",
      required: true
    }), React.createElement("span", {
      className: "checkmark"
    })), React.createElement("label", null, React.createElement("input", {
      className: "false",
      type: "radio",
      name: "functional",
      value: "false",
      checked: functional === false,
      onChange: this.handleChange,
      "aria-label": "D\xE9sactiver le suivi fonctionnel",
      required: true
    }), React.createElement("span", {
      className: "checkmark"
    }))), lang === 'it' ? React.createElement(RowHeading, {
      scope: "row"
    }, "Funzionale") : React.createElement(RowHeading, {
      scope: "row"
    }, "Fonctionnel"), lang === 'it' ? React.createElement("td", null, React.createElement("p", null, "Per monitorare l\u2019andamento del sito e migliorare l\u2019esperienza di navigazione degli utenti. Ad esempio, per comunicare via chat."), React.createElement("p", {
      className: hideOnMobile
    }, "Ad esempio, per comunicare con te tramite una chat.")) : React.createElement("td", null, React.createElement("p", null, "Pour surveilleer la performance de notre site et am\xE9liorer votre exp\xE9rience de navigation."), React.createElement("p", {
      className: hideOnMobile
    }, "Par exemple, pour communiquer avec vous via un chat.")), React.createElement("td", {
      className: hideOnMobile
    }, functionalDestinations.map(function (d) {
      return d.name;
    }).join(', '))), React.createElement(Row, null, React.createElement(InputCell, null, React.createElement("label", null, React.createElement("input", {
      className: "true",
      type: "radio",
      name: "marketingAndAnalytics",
      value: "true",
      checked: marketingAndAnalytics === true,
      onChange: this.handleChange,
      "aria-label": "Activer le suivi marketing et d'analyse",
      required: true
    }), React.createElement("span", {
      className: "checkmark"
    })), React.createElement("label", null, React.createElement("input", {
      className: "false",
      type: "radio",
      name: "marketingAndAnalytics",
      value: "false",
      checked: marketingAndAnalytics === false,
      onChange: this.handleChange,
      "aria-label": "Désactiver le suvi marketing et d'analyse",
      required: true
    }), React.createElement("span", {
      className: "checkmark"
    }))), lang === 'it' ? React.createElement(RowHeading, {
      scope: "row"
    }, "Marketing e analisi") : React.createElement(RowHeading, {
      scope: "row"
    }, "Marketing et analyse"), lang === 'it' ? React.createElement("td", null, React.createElement("p", null, "Per comprendere al meglio il comportamento degli utenti e fornire un\u2019esperienza personalizzata."), React.createElement("p", {
      className: hideOnMobile
    }, "Ad esempio, raccogliamo le informazioni sulle pagine consultate per fornire un contenuto pi\xF9 adatto alle tue ricerche.")) : React.createElement("td", null, React.createElement("p", null, "Pour mieux comprendre le comportement de nos utilisateur et fournir une exp\xE9rience personnalis\xE9e."), React.createElement("p", {
      className: hideOnMobile
    }, "Par exemple, nous collectons des informations sur les pages que vous visitez pour vous fournir du contenu plus pertinent.")), React.createElement("td", {
      className: hideOnMobile
    }, marketingDestinations.map(function (d) {
      return d.name;
    }).join(', '))), React.createElement(Row, null, React.createElement(InputCell, null, React.createElement("label", null, React.createElement("input", {
      className: "true",
      type: "radio",
      name: "advertising",
      value: "true",
      checked: advertising === true,
      onChange: this.handleChange,
      "aria-label": 'Activer le suivi publicitaire',
      required: true
    }), React.createElement("span", {
      className: "checkmark"
    })), React.createElement("label", null, React.createElement("input", {
      className: "false",
      type: "radio",
      name: "advertising",
      value: "false",
      checked: advertising === false,
      onChange: this.handleChange,
      "aria-label": 'Désactiver le suivi publicitaire',
      required: true
    }), React.createElement("span", {
      className: "checkmark"
    }))), lang === 'it' ? React.createElement(RowHeading, {
      scope: "row"
    }, "Essenziale") : React.createElement(RowHeading, {
      scope: "row"
    }, "Publicit\xE9"), lang === 'it' ? React.createElement("td", null, React.createElement("p", null, "Questo sito fa uso di cookies essenziali per il suo funzionamento."), React.createElement("p", {
      className: hideOnMobile
    }, "Ad esempio, memorizziamo le preferenze di raccolta dati personali per gli accessi futuri. \xC8 possibile disattivare i cookies nelle impostazioni del browser, compromettendo per\xF2 il corretto funzionamento del sito.")) : React.createElement("td", null, React.createElement("p", null, "Pour personnaliser et mesurer l'efficacit\xE9 de la publicit\xE9 sur notre site et des sites tiers."), React.createElement("p", {
      className: hideOnMobile
    }, "Par exemple, nous pouvons afficher une publicit\xE9 bas\xE9e sur les pages que vous avez visit\xE9es sur notre site.")), React.createElement("td", {
      className: hideOnMobile
    }, advertisingDestinations.map(function (d) {
      return d.name;
    }).join(', ')))), customCategories && Object.entries(customCategories).map(function (_a) {
      var categoryName = _a[0],
          _b = _a[1],
          integrations = _b.integrations,
          purpose = _b.purpose;
      return React.createElement(Row, {
        key: categoryName
      }, React.createElement(InputCell, null, React.createElement("label", null, React.createElement("input", {
        className: "true",
        type: "radio",
        name: categoryName,
        value: "true",
        checked: preferences[categoryName] === true,
        onChange: _this.handleChange,
        "aria-label": "Autoriser le suivi \"" + categoryName + "\"",
        required: true
      }), React.createElement("span", {
        className: "checkmark"
      })), React.createElement("label", null, React.createElement("input", {
        className: "false",
        type: "radio",
        name: categoryName,
        value: "false",
        checked: preferences[categoryName] === false,
        onChange: _this.handleChange,
        "aria-label": "D\xE9sactiver le suivi \"" + categoryName + "\"",
        required: true
      }), React.createElement("span", {
        className: "checkmark"
      }))), React.createElement(RowHeading, {
        scope: "row"
      }, categoryName), React.createElement("td", null, React.createElement("p", null, purpose)), React.createElement("td", {
        className: hideOnMobile
      }, destinations.filter(function (d) {
        return integrations.includes(d.id);
      }).map(function (d) {
        return d.name;
      }).join(', ')));
    }), React.createElement(Row, null, React.createElement("td", null, "N/A"), lang === 'it' ? React.createElement(RowHeading, {
      scope: "row"
    }, "Essenziale") : React.createElement(RowHeading, {
      scope: "row"
    }, "Essentiel"), lang === 'it' ? React.createElement("td", null, React.createElement("p", null, "Utilizziamo cookie essenziali per il funzionamento del nostro sito."), React.createElement("p", null, "Ad esempio, salviamo le tue preferenze di raccolta dati dati personali al fine di rispettarli per le vostre future visite. Puoi disabilitare i cookie nelle preferenze del tuo browser ma il sito potrebbe non funzionare correttamente.")) : React.createElement("td", null, React.createElement("p", null, "Nous utilisons des cookies essentiels pour le fonctionnement de notre site."), React.createElement("p", null, "Par exemple, nous sauvegardons vos pr\xE9f\xE9rences de collecte de donn\xE9es personnelles afin de les respecter pour vos visites futures. Vous pouvez d\xE9sactiver les cookies dans les pr\xE9f\xE9rences de votre navigateur mais le site pourrait ne pas fonctionner correctement.")), React.createElement("td", {
      className: hideOnMobile
    }))))));
  };

  PreferenceDialog.displayName = 'PreferenceDialog';
  PreferenceDialog.defaultProps = {
    marketingAndAnalytics: false,
    advertising: false,
    functional: false
  };
  return PreferenceDialog;
}(PureComponent);

export default PreferenceDialog;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;